import React from 'react';
// import elements
import IsobaricTabRadioGroup from '../elements/IsobaricTab.RadioGroup';
import IsobaricTabTable from '../elements/IsobaricTab.Table';

export default class IsobaricLabelTab extends React.Component{

  render(){
    const {isobaricLabelList, isobaricLabelTable, updateParameters, parameters} = this.props;

    return(
      <div>
        <div className="parameters-subcategory-title-wrapper">
          <div>Set Isobaric Lables</div>
        </div>
        <IsobaricTabRadioGroup 
          isobaricLabelList={isobaricLabelList}
          isobaricLabelTable={isobaricLabelTable}
          updateParameters={updateParameters}
          parameters={parameters} />
        <IsobaricTabTable 
          updateParameters={updateParameters}
          parameters={parameters} />
      </div>
    )
  }
};